/* eslint-disable no-restricted-syntax */
/* eslint-disable custom/max-top-level-functions-per-file */

export const DEFAULT_ACT_MODAL_ID = 0

let actModalId = DEFAULT_ACT_MODAL_ID

/** Az aktuális modal ID-ját adja vissza. */
export function getActModalId (): string {
  return `sen-modal-${ actModalId }`
}

/** ActModalId növelése. */
export function increaseModalId (): void {
  actModalId++
}
